import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import initializeAOS from "../utils/aosLibrary";
import IT_image2 from "../assets/IT Staffing_2.png";
import IT_image4 from "../assets/IT Staffing_4.png";
import IT_image5 from "../assets/IT Staffing_5.png";
import Iconbox from "../../src/assets/Group 5.png";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import EnouthTalk from "../Components/EnouthTalk";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";


function Itstaffing() {
  const fontLivic = "Livvic , sans-serif";
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const { t } = useTranslation();
  useEffect(() => {
    document.title =
      "IT Staffing Company | Technology Staffing Services and Solutions  ";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Fundnest provides expert IT staffing services to help businesses find the right talent. Our tailored solutions connect you with skilled professionals for your tech needs."
    );
    initializeAOS();
  }, []);

  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div data-aos="fade-up">
          <h1
            style={{
              fontSize: isXs ? "64px" : "50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
              textAlign: isXs ? "" : "center",
            }}
          >
            {t('service.itStaffing.heading')}
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
            width: isXs ? "" : "80%",
            maxWidth: "700px",
          }}
        >
          {t('service.itStaffing.headline')}
        </div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            display: isXs ? "flex" : "none",
            position: "absolute",
            right: "0",
            top: "200px",
          }}
          src={line_vector}
          alt=""
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: isXs ? "0px 60px" : "0px 30px",
          paddingTop: isXs ? "90px" : "90px",
          flexDirection: isXs ? "" : "column-reverse",
        }}
      >
        <div
          data-aos="fade-right"
          style={{
            width: isXs ? "50%" : "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: isXs ? "450px" : "400px",
              height: isXs ? "450px" : "400px",
              marginTop: isXs ? "" : "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src={IT_image4}
              alt="Image"
            />
          </div>
        </div>
        <div
          style={{
            width: isXs ? "50%" : "100%",
            display: "flex",
            gap: "30px",
            paddingTop: isXs ? "80px" : "",
            paddingRight: isXs ? "60px" : "0px",
            flexDirection: isXs ? "column" : "column",
          }}
        >
          <div
            data-aos="fade-up"
            style={{ fontWeight: "600", fontSize: "34px" }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[0]['title']}
          </div>
          <div
            data-aos="fade-up"
            style={{ fontFamily: fontLivic, letterSpacing: "1px" }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[0]['paragraph_1']}
          </div>
          <div
            data-aos="fade-up"
            style={{ fontFamily: fontLivic, letterSpacing: "1px" }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[0]['paragraph_2']}
          </div>
          <div
            data-aos="fade-up"
            style={{ fontFamily: fontLivic, letterSpacing: "1px" }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[0]['paragraph_3']}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          padding: isXs ? "90px 60px 0px 60px" : "90px 30px 0px 30px",
          gap: "20px",
          flexDirection: isXs ? "" : "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: isXs ? "60%" : "100%",
          }}
        >
          <div
            data-aos="fade-left"
            style={{ fontSize: "24px", fontWeight: "600" }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[1]['title']}
          </div>
          <div
            data-aos="fade-left"
            style={{
              fontFamily: fontLivic,
              marginTop: "15px",
              marginBottom: "20px",
            }}
          >
            {t('service.itStaffing.sections', { returnObjects: true })[1]['content']}
          </div>

          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              1. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][0]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][0]['description']}
            </div>
          </div>
          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              2. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][1]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][1]['description']}
            </div>
          </div>
          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              3. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][2]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {" "}
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][2]['description']}
            </div>
          </div>
          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              4. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][3]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][3]['description']}
            </div>
          </div>
          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              5. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][4]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][4]['description']}
            </div>
          </div>
          <div data-aos="fade-left" style={{ paddingBottom: "18px" }}>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0.5",
              }}
            >
              {" "}
              6. {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][5]['heading']}
            </div>
            <div
              style={{
                fontFamily: fontLivic,
                paddingLeft: "20px",
                paddingRight: isXs ? "160px" : "0px",
              }}
            >
              {t('service.itStaffing.sections', { returnObjects: true })[1]['subsections'][5]['description']}
            </div>
          </div>
        </div>
        <div style={{ marginTop: "0px" }}>
          <div
            style={{
              width: "400px",
              height: "320px",
              position: "absolute",
              zIndex: "1",
              display: isXs ? "" : "none",
            }}
          >
            <img
              data-aos="fade-down-left"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              src={IT_image2}
              alt=""
            />
          </div>
          <div
            style={{
              width: isXs ? "400px" : "",
              height: isXs ? "300px" : "400px",
              marginTop: isXs ? "400px" : "20px",
            }}
          >
            <img
              data-aos="fade-up-right"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              src={IT_image5}
              alt=""
            />
          </div>
        </div>
      </div>

      <div style={{ padding: isXs ? "90px 60px" : "90px 30px" }}>
        <div
          data-aos="fade-down"
          style={{ fontSize: "32px", fontWeight: "600", marginBottom: "20px" }}
        >
          {t('service.itStaffing.sections', { returnObjects: true })[2]['title']}
        </div>
        <div
          data-aos="fade-down"
          style={{
            fontFamily: fontLivic,
            letterSpacing: "0.5px",
            lineHeight: "1.667",
            fontSize: "18px",
            maxWidth: "70%"
          }}
        >
          {t('service.itStaffing.sections', { returnObjects: true })[2]['content']}
        </div>

        <div
          style={{
            display: "flex",
            padding: "40px 0px",
            flexDirection: isXs ? " " : "column",
            gap: isXs ? "" : "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              paddingRight: isXs ? "40px" : "0px",
            }}
          >
            <div
              data-aos="fade-right"
              style={{ display: "flex", gap: "10px", alignItems: "start" }}
            >
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][0]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][0]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-right" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][1]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][1]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-right" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][2]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][2]['description']}
                </div>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-left"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              paddingRight: isXs ? "40px" : "0px",
            }}
          >
            <div style={{ display: "flex", gap: "10px", alignItems: "start" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][3]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][3]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-left" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][4]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][4]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-left" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][5]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[2]['subsections'][5]['description']}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          padding: isXs ? "0px 60px" : "0px 30px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          data-aos="fade-down"
          style={{ fontSize: "34px", fontWeight: "600" }}
        >
          {t('service.itStaffing.sections', { returnObjects: true })[3]['title']}
        </div>
        <div
          data-aos="fade-down"
          style={{
            fontSize: "180x",
            fontFamily: fontLivic,
            letterSpacing: "1px",
            marginTop: "20px",
            maxWidth: "70%"
          }}
        >
          {t('service.itStaffing.sections', { returnObjects: true })[3]['content']}
        </div>
        <div
          style={{
            display: "flex",
            padding: "40px 0px",
            gap: "50px",
            flexDirection: isXs ? "row" : "column",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              padding: isXs ? "0px 100px 0px 10px" : "0px 0px 0px 10px",
            }}
          >
            <div
              data-aos="fade-right"
              style={{ display: "flex", gap: "10px", alignItems: "start" }}
            >
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][0]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][0]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-right" style={{ display: "flex", gap: "10px" }}>
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][1]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][1]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-right" style={{ display: "flex", gap: "10px" }}>
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][2]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][2]['description']}
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              padding: isXs ? "0px 100px 0px 10px" : "0px 0px 0px 10px",
            }}
          >
            {" "}
            <div
              data-aos="fade-left"
              style={{ display: "flex", gap: "10px", alignItems: "start" }}
            >
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][3]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][3]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-left" style={{ display: "flex", gap: "10px" }}>
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][4]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][4]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-left" style={{ display: "flex", gap: "10px" }}>
              <div>
                <CheckCircleOutlineIcon />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    marginTop: "5px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][5]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('service.itStaffing.sections', { returnObjects: true })[3]['subsections'][5]['description']}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EnouthTalk />
      <Footer />
    </>
  );
}

export default Itstaffing;
